"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.armeniaTranslations = void 0;
var _types = require("../../../types");
const armeniaTranslations = exports.armeniaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Ցավում ենք:',
  [_types.ErrorPageTranslationKey.buttonText]: 'Հետ',
  [_types.ErrorPageTranslationKey.text]: 'Ներկա պահին տվյալ էջը հասանելի չէ',
  [_types.ErrorPageTranslationKey.notFound]: 'Դուք փնտրել էջը մատչելի չէ',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Էջը, որին փորձում եք մուտք գործել, սահմանափակված է, և բոլոր չափանիշները չեն բավարարվել:',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Խնդրում ենք կապվել Օրիֆլեյմի աջակցման թիմին էլ.',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Հայցվող URL-ը մերժվել է:'
};
